import React from "react";
import Typography from "material-ui/Typography";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui/Dialog";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
const DeleteChoiceConfirm = props => (
  <Dialog
    disableBackdropClick
    disableEscapeKeyDown
    maxWidth="sm"
    open={props.open}
  >
    <DialogTitle className={props.classes.title}>
      {props.title}
      <Button className={props.classes.close} onClick={props.onCancel}>
        <Icon>clear</Icon>
      </Button>
    </DialogTitle>
    <DialogContent>
      <Typography gutterBottom className={props.classes.HighlightUserDetails}>
        {props.contentText}
      </Typography>
      <Typography className={props.classes.confirmSecondaryText}>
        {props.contentSecondaryText}
      </Typography>
    </DialogContent>
    <DialogActions>
      {props.okDeleteTestText && (
        <Button
          className={props.classes.submit}
          onClick={props.onDeleteTest}
          color="primary"
        >
          {props.okDeleteTestText}
        </Button>
      )}
      <div style={{ flex: '1 0 0' }} />
      {props.okDeleteSubTestText && (
        <Button
          className={props.classes.submit}
          onClick={props.onDeleteSubTest}
          color="primary"
          style={{ marginRight: '10px'}}
        >
          {props.okDeleteSubTestText}
        </Button>
      )}
    </DialogActions>
  </Dialog>
);
export default withStyles(styles)(DeleteChoiceConfirm);



// WEBPACK FOOTER //
// ./src/components/job/signaltek10g/delete/deletechoice/index.js